import { AppBar, Button, Collapse, IconButton, Link, Menu, Stack, Typography, useMediaQuery } from "@mui/material";
import { lightTheme } from "../Themes";
import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";
import { globalMaxWidth } from "../GlobalConfigs";
import Simposio from "../SimposioPage";
import { useNavigate } from "react-router-dom";

export function NavigationMenu() {

    const compact_layout = useMediaQuery(lightTheme.breakpoints.down('xl'), {
        defaultMatches: true
    });

    let [dropdownOpen, setDropdownOpenState] = useState(false);

    const NavigationMenuItem = (props) => {
        const { href, text } = props;
        return (
            <Link component={Button} href={href} underline='none' onClick={() => {
                setAnchorEl(null);
                setDropdownOpenState(false);
            }}>
                <Typography variant="h6" color='white' align='left' sx={{ width: 1 }}>
                    {text}
                </Typography>
            </Link>
        );
    }

    const toggleDrawer = (open) => (event) => {
        if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setDropdownOpenState(open);
    };

    const [anchorEl, setAnchorEl] = useState(null);


    function getStack() {

        const open = Boolean(anchorEl);
        const handleDropdownClick = (event) => {
            setAnchorEl(event.currentTarget);
        };

        function handleDropdownClose() {
            setAnchorEl(null);
        }

        return <>
            <NavigationMenuItem href='/' text='Home' />
            <Button
                variant="text"
                disableElevation
                onClick={handleDropdownClick}
                endIcon={<KeyboardArrowDownIcon />}
            >
                <Typography variant="h6" color='white'>
                    Simposio URSI 2026
                </Typography>
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleDropdownClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
                sx={{
                    overflow: 'hidden',
                    position: 'absolute',
                    "& .MuiMenu-paper":
                        { backgroundColor: 'secondary.main', },
                }}
            >
                <Stack>
                    <NavigationMenuItem href='/simposio/programas' text='Programas' idx={0}/>
                    <NavigationMenuItem href='/simposio/fechas' text='Fechas Importantes' idx={1} />
                    <NavigationMenuItem href='/simposio/areas' text='Áreas Temáticas' idx={2} />
                    <NavigationMenuItem href='/simposio/comites' text='Comités' idx={3} />
                    <NavigationMenuItem href='/simposio/sede' text='Sede' idx={4} />
                    <NavigationMenuItem href='/simposio/comunicaciones' text='Comunicaciones' idx={5} />
                    <NavigationMenuItem href='/simposio/inscripciones' text='Inscripciones y Tarifas' idx={6} />
                    <NavigationMenuItem href='/simposio/premios' text='Premios y Concursos' idx={7} />
                </Stack>
            </Menu>
            <NavigationMenuItem href='/novedades' text='Novedades' />
            <NavigationMenuItem href='/patrocinadores' text='Patrocinadores' />
            <NavigationMenuItem href='/alojamiento' text='Alojamiento' />
            <NavigationMenuItem href='https://www.webtenerife.com/' text='Turismo' />
            <NavigationMenuItem href='/contacto' text='Contacto' />
            <NavigationMenuItem href='https://ursi.es/' text='URSI' />
        </>;
    }

    return (

        <AppBar position="sticky">
            {compact_layout ?
                <Stack alignItems='flex-start' justifyContent='center' spacing={0} sx={{
                    backgroundColor: 'secondary.main', width: 1
                }}>
                    <IconButton
                        size="large"
                        edge="start"
                        aria-label="menu"
                        onClick={toggleDrawer(!dropdownOpen)}
                        sx={{
                            m: 0.5
                        }}
                    >
                        <MenuIcon color="action" />
                    </IconButton>
                    <Collapse in={dropdownOpen}>
                        <Stack direction="column" justifyContent='space-evenly' alignItems='left' spacing={0}
                            sx={{
                                m: 2
                            }}
                        >
                            {getStack()}
                        </Stack>
                    </Collapse>
                </Stack>
                :
                <Stack alignItems='center' justifyContent='center' sx={{
                    backgroundColor: 'secondary.main', height: '45px', width: 1
                }}>
                    <Stack direction="row" justifyContent='space-evenly' alignItems='center' sx={{
                        width: 1, maxWidth: globalMaxWidth
                    }}>
                        {getStack()}
                    </Stack>
                </Stack>
            }
        </AppBar>
    )
}